import React, { Component } from 'react'
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit,faCheckCircle, faTimesCircle, faPen} from '@fortawesome/free-solid-svg-icons';
import LaunchTraining from './LaunchAssessment';
import { Util } from '../../../config/Util';
import axios from 'axios';
import {API} from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import './EmplAssessment.css';
import LaunchAssessment from './LaunchAssessment';
import ToastComp from '../../../components/Toast/Toast';

export default class EmplAssessment extends Component {
  
constructor(){
    super();
    this.rowData = {};
    this.columns = [
      {
          id: 'id',
          name: 'ID',
          selector: row => row.id, 
          center:true,
          grow:0.5
      },
      {
          name: 'TITLE',
          selector: row => row.name,
          grow:3,
          center:true
      },
      {
        name: 'DUE DATE',
        selector: row => row.dueDate,
        center:true
      },
      {
        id:"status",
        center:true,
        name:"STATUS",
        cell: props => {
          return props.status === 'Completed' ? 
              <button disabled id={props.id} className='btn btn-success'  > 
              <FontAwesomeIcon icon={faCheckCircle} className='table-icon-inline'/> COMPLETED</button>
          : ( props.status === 'Submitted' ? <button disabled id={props.id} className='btn btn-info' > 
          <FontAwesomeIcon icon={faCheckCircle} className='table-icon-inline'/> SUBMITTED</button>
          : <button disabled id={props.id} className='btn btn-danger' > 
          <FontAwesomeIcon icon={faTimesCircle} className='table-icon-inline'/> PENDING</button>)

       },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        minWidth:"150px"
      },
      {
        
        minWidth:"150px",
        cell: props => {
          return (props.status !== 'Completed' && props.status !== 'Submitted') ? 
              <button  id={props.id} className='btn btn-info'  onClick={()=>this.launch(props)}> 
              <FontAwesomeIcon icon={faPen} className='table-icon-inline'/> LAUNCH</button>:''
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    
  ]
    this.state = {
      data : [],
      fullData:[],
      toggleForm : false,
      toggleAssignForm : false,
      toggleAddForm:false,
      editForm :  false,
      loader : false,
      certUrl :'',
      validateError : false
    }
    this.assessmentDetailObj = {};
    
}
//Search fn
filterData = (e)=>{
  const key = e.target.value;
  let ar=[];
  this.state.fullData.forEach(element => {
    if(element.name.toLowerCase().indexOf(key.toLowerCase())>-1) 
    ar.push(element);
  });
  this.setState({data : ar})
}

launch =(props)=>{
  this.rowData = props;
  this.setState({loader : true});
  axios.get(API.listAssessment+"/"+props.id).then((res)=>{
    if(res && res.data && res.data.status ==='S'){
      this.assessmentDetailObj = res.data;
    }
  }).catch((er)=>{

  }).finally(()=>{
    this.setState({toggleForm : true});
    this.setState({loader : false});
  })
    
}
updateToggleFormVal = ()=>{
  this.setState({toggleForm : false});
}
componentDidMount(){
  this.loadData();
}

getUserDetails=(id)=>{
  this.setState({loader:true});
  axios.get(API.getUserDetail+id).then((res)=>{
      if(res.data && res.data.status ==='S'){
          Util.saveToSession("userData",res.data);
      }
      this.setState({loader:false});
  }).catch((er)=>{
      this.setState({loader:false});
  }).finally(()=>{
    this.loadData();
  })
}

loadData =()=>{
  let assessments = [];
  let d = Util.getFromSession("userData");
  if(d && d.assessments && d.assessments.length) assessments=d.assessments;

  this.setState({data:assessments});
  this.setState({fullData: assessments});
}

updateTestStatus = (req,callback)=>{
  this.setState({loader : true});
  let user = Util.getFromSession("userData");
  req.userId = user.id;
  axios.post(API.updateTestStatus,req).then((res)=>{
    if(res && res.data && res.data.status ==='S'){
      this.getUserDetails(user.id);
      callback(res.data);
    }
  }).catch((er)=>{

  }).finally(()=>{
    this.setState({loader : false});
   // this.setState({toggleForm:false});
  })
}
//Validate attempts
validateAttempt =(req,callback)=>{
  this.setState({loader : true});
  let user = Util.getFromSession("userData");
  req.userId = user.id;
  axios.post(API.checkIfAttemptAllowed,req).then((res)=>{
    if(res && res.data && res.data.status ==='S'){
      if(res.data.isAttemptAllowed == "Y"){
        callback("Y");
      }else{
        this.setState({validateError : true});
        callback("N");
      }
    }else{
      this.setState({validateError : true});
      callback("N")
    }
  }).catch((er)=>{
    this.setState({validateError : true});
    callback("N")
  }).finally(()=>{
    this.setState({loader : false});
  })
}

  render() {
    
    return (
      <div>
      {this.state.validateError ? <ToastComp case='no-attempt' handler={()=>{this.setState({validateError:false})}}/> : ""}
      <Loader loading={this.state.loader}></Loader>
      {this.state.toggleForm ? <LaunchAssessment validateAttept={this.validateAttempt} cert={this.state.certUrl} updateStatus={this.updateTestStatus} data={this.assessmentDetailObj} handler={this.updateToggleFormVal} flag={this.state.toggleForm? true : false}/> : ''}

      <div className='bread-crumb overflow-auto'>
      <div>
      <span className='breadcrumb-title'>
        <input type='button' className='btn' value='Home - Assessment'></input>
      </span>
     
      </div>
      </div>
      <div className='data-table-holder'>
        <div className='table-search-box'>
        <input type='text' placeholder="Search Here.." className='form-control' onChange={(e)=>this.filterData(e)}></input>
        </div>
      <DataTable subHeaderAlign="center"
      columns={this.columns} defaultSortFieldId="id"
      data={this.state.data} pagination striped
     
      />
      </div>
      </div>
    )
  }
}
